<template>
    <div class="layout__container">

        <!--<div class="layout__margin-25-0">-->
            <!--<el-breadcrumb separator-class="el-icon-arrow-right">-->
                <!--<el-breadcrumb-item :to="{ path: '/' }">Admin</el-breadcrumb-item>-->
            <!--</el-breadcrumb>-->
        <!--</div>-->

        <div class="layout__border__radius-10 layout__width-100 layout__position-left layout__padding-15-0 text__align-center text__colour-teal">
            <h2>Ravensworth Administration Portal</h2>
            <p class="layout__padding__top-10px">Navigate through all admin facilities.</p>
        </div>


        <!--<div class="layout__display-block layout__width-100">-->

            <div class="component__200px__columns-2 text__align-center layout__border__all-1px-dotted layout__position-left layout__margin__bottom-10 layout__border__radius-10">

                <div class="layout__width-30 layout__position-left">
                    icon
                </div>
                <div class="layout__width-70 layout__position-left text__align-left">
                    <h3 class="text__colour-teal layout__padding-20-0">Customer Orders</h3>
                    <ul>
                        <li class="layout__padding-5-0">Search Customer Orders by Id, Status, Product, Duration</li>
                        <li class="layout__padding-5-0">(includes download artwork features)</li>
                    </ul>
                </div>
            </div>

        <div class="component__200px__columns-2 text__align-center layout__border__all-1px-dotted layout__position-left layout__margin__bottom-30 layout__border__radius-10">

            <div class="layout__width-30 layout__position-left">
                icon
            </div>
            <div class="layout__width-70 layout__position-left text__align-left">
                <h3 class="text__colour-teal layout__padding-20-0">Support Tools</h3>
                <ul>
                    <li class="layout__padding-5-0">Upload Completed Photofixr Photos</li>
                </ul>
            </div>
        </div>

            <div class="component__200px__columns-2 text__align-center layout__border__all-1px-dotted layout__position-left layout__margin__bottom-30 layout__border__radius-10">

                <div class="layout__width-30 layout__position-left">
                    icon
                </div>
                <div class="layout__width-70 layout__position-left text__align-left">
                    <h3 class="text__colour-teal layout__padding-20-0">Orders Admin</h3>
                    <ul>
                        <li class="layout__padding-5-0">Search Customer Details</li>
                        <li class="layout__padding-5-0">Search Orders by Id, Status, Product, Duration</li>
                        <li class="layout__padding-5-0">Search or Create Bespoke Orders</li>
                        <li class="layout__padding-5-0">Search and Download Invoices</li>
                    </ul>
                </div>
            </div>
        <!--</div>-->

        <!--<div class="layout__display-block layout__width-100">-->

            <div class="component__200px__columns-2 text__align-center layout__border__all-1px-dotted layout__position-left layout__margin__bottom-30 layout__border__radius-10">

                <div class="layout__width-30 layout__position-left">
                    icon
                </div>
                <div class="layout__width-70 layout__position-left text__align-left">
                    <h3 class="text__colour-teal layout__padding-20-0">Billing Admin</h3>
                    <ul>
                        <li class="layout__padding-5-0">Search Customer Details</li>
                        <li class="layout__padding-5-0">Create New Customers**</li>
                        <li class="layout__padding-5-0">Search Orders by Id, Status, Product, Duration</li>
                        <li class="layout__padding-5-0">Search and Download Invoices</li>
                    </ul>
                </div>
            </div>

            <div class="component__200px__columns-2 text__align-center layout__border__all-1px-dotted layout__position-left layout__margin__bottom-30 layout__border__radius-10">

                <div class="layout__width-30 layout__position-left">
                    icon
                </div>
                <div class="layout__width-70 layout__position-left text__align-left">
                    <h3 class="text__colour-teal layout__padding-20-0">Sales Insights</h3>
                    <ul>
                        <li class="layout__padding-5-0">Bespoke Reports, Category Sales</li>
                        <li class="layout__padding-5-0">Customer Sales, Customer Status, Lapsed Customers</li>
                        <li class="layout__padding-5-0">New Sales, Product Sales, Territory Sales, Total Sales</li>
                    </ul>
                </div>
            </div>

        <div class="component__200px__columns-2 text__align-center layout__border__all-1px-dotted layout__position-left layout__margin__bottom-30 layout__border__radius-10">

            <div class="layout__width-30 layout__position-left">
                icon
            </div>
            <div class="layout__width-70 layout__position-left text__align-left">
                <h3 class="text__colour-teal layout__padding-20-0">System Admin*</h3>
                <ul>
                    <li class="layout__padding-5-0">Search Products Codes</li>
                    <li class="layout__padding-5-0">Create New Products Codes</li>
                    <li class="layout__padding-5-0">Search Price Codes</li>
                    <li class="layout__padding-5-0">Create New Price Codes</li>
                </ul>

                <p class="layout__padding__top-50px text__align-right">* Restricted Management Tool Only</p>
                <p class="text__align-right">** Availability dependant on permissions</p>
            </div>
        </div>
        <!--</div>-->

    </div>

</template>

<script>
    import Vue from 'vue';
    import Element from 'element-ui';
    import {axios} from '@/mixins/Axios.js';
    import Axios from 'axios';
    // import {cookie} from '@/mixins/Cookie.js';

    Vue.use(Element);

    export default {
        name: "start",
        mixins: [axios],
        data() {
            return {}
        },
        computed: {},
        created() {

        },
        mounted() {
        },
        methods: {}

    };
</script>